import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
/** @jsx jsx */
import React from 'react';
import AKBadge from '@atlaskit/badge';
import { css, jsx } from '@emotion/react';
var badgeStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  display: inline-flex;\n"])));

/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */

var AtlaskitBadge = function AtlaskitBadge(_ref) {
  var value = _ref.value,
    name = _ref.name,
    overrideCss = _ref.overrideCss,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-element-atlaskit-badge' : _ref$testId;
  if (!value) {
    return null;
  }
  return jsx("span", {
    css: [badgeStyles, overrideCss],
    "data-fit-to-content": true,
    "data-smart-element": name,
    "data-smart-element-atlaskit-badge": true,
    "data-testid": testId
  }, jsx(AKBadge, null, value));
};
export default AtlaskitBadge;